import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const FilterLevelSecondSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocation.availableFilters.level_2);
  const selectedOptions = useSelector((state) => state.multiLocation.selectedLevelSecond);

  const title = useSelector((state) => state.multiLocation.availableFilters.filter_titles[1]);

  const secondLevelFiltersLoading = useSelector(
    (state) => state.multiLocation.secondLevelFiltersLoading
  );

  return secondLevelFiltersLoading ? (
    <LoadingAnimation uiLoader />
  ) : (
    <>
      <p>{title}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOptions}
        placeholder="Please Select"
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFiltersRequest({ name: "FilterLevelSecond", data: data }))
        }
      />
    </>
  );
};

export default FilterLevelSecondSelect;
